import { apiFetch } from './api';

export interface PublicInstance {
  version: string;
  licenseStatus: 'active' | 'suspended';
  licenseMessage: string | null;
  /** Brand name of the default firm; absent on older instances, null when not set. */
  brandName?: string | null;
  /** https URL or a path on the instance (/api/public/instance/logo?v=…). */
  logoUrl?: string | null;
}

/** Unauthenticated: version + licence status, readable even while suspended. */
export async function fetchPublicInstance(): Promise<PublicInstance> {
  const res = await apiFetch<{ success: boolean; data: PublicInstance }>('/api/public/instance');
  return res.data;
}
